import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  FormFeedback,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import API from "../../api/axios"
import { toast } from "react-toastify"

const PasswordResetModel = ({ isOpen, toggle, targetUser }) => {
  const [loading, setLoading] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Must contain at least one uppercase letter")
        .matches(/[a-z]/, "Must contain at least one lowercase letter")
        .matches(/[0-9]/, "Must contain at least one number")
        .required("New password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),

    onSubmit: async values => {
      try {
        setLoading(true)
        const token = localStorage.getItem("authToken")
        const response = await API.post(
          "api/users/change-password",
          {
            targetUserId: targetUser.id,
            newPassword: values.newPassword,
            confirmPassword: values.confirmPassword,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )

        console.log("change password response✨🧨", response.data)

        toast.success("Password reset successfully!")
        toggle()
      } catch (error) {
        toast.error(error.response.data.message || "Failed to reset password")
      } finally {
        setLoading(false)
      }
    },
  })

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Reset Password for {targetUser?.fname} {targetUser?.lname}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={validation.handleSubmit}>
          <div className="mb-3">
            <Label>New Password</Label>
            <Input
              name="newPassword"
              type="password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.newPassword}
              invalid={
                validation.touched.newPassword &&
                !!validation.errors.newPassword
              }
            />
            {validation.touched.newPassword &&
              validation.errors.newPassword && (
                <FormFeedback>{validation.errors.newPassword}</FormFeedback>
              )}
          </div>

          <div className="mb-3">
            <Label>Confirm Password</Label>
            <Input
              name="confirmPassword"
              type="password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.confirmPassword}
              invalid={
                validation.touched.confirmPassword &&
                !!validation.errors.confirmPassword
              }
            />
            {validation.touched.confirmPassword &&
              validation.errors.confirmPassword && (
                <FormFeedback>{validation.errors.confirmPassword}</FormFeedback>
              )}
          </div>

          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            <Button type="submit" color="primary" disabled={loading}>
              {loading ? "Updating..." : "Reset Password"}
            </Button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default PasswordResetModel
